import { render, staticRenderFns } from "./topic_edit.vue?vue&type=template&id=802fc722&scoped=true"
import script from "./topic_edit.vue?vue&type=script&lang=js"
export * from "./topic_edit.vue?vue&type=script&lang=js"
import style0 from "./topic_edit.vue?vue&type=style&index=0&id=802fc722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802fc722",
  null
  
)

export default component.exports